import * as React from 'react';
import SVGEnterprise from '@splunk/react-icons/SVGEnterprise';

const Timeline = (props: React.ComponentProps<typeof SVGEnterprise>): React.ReactElement<SVGElement> => (
    <SVGEnterprise viewBox="1.5 2 9 8" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 2C2.27614 2 2.5 2.22386 2.5 2.5V9H10C10.2761 9 10.5 9.22386 10.5 9.5C10.5 9.77614 10.2761 10 10 10H2.25C1.83579 10 1.5 9.66421 1.5 9.25V2.5C1.5 2.22386 1.72386 2 2 2ZM4 3C4 2.72386 4.22386 2.5 4.5 2.5H7.5C7.77614 2.5 8 2.72386 8 3C8 3.27614 7.77614 3.5 7.5 3.5H4.5C4.22386 3.5 4 3.27614 4 3ZM5.5 5C5.5 4.72386 5.72386 4.5 6 4.5H7.5C7.77614 4.5 8 4.72386 8 5C8 5.27614 7.77614 5.5 7.5 5.5H6C5.72386 5.5 5.5 5.27614 5.5 5ZM5.5 7C5.5 6.72386 5.72386 6.5 6 6.5H9.5C9.77614 6.5 10 6.72386 10 7C10 7.27614 9.77614 7.5 9.5 7.5H6C5.72386 7.5 5.5 7.27614 5.5 7Z"
            fill="currentColor"
        />
    </SVGEnterprise>
);

export default Timeline;
